import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

/**
 * Pending-access count next to the Tasks nav link — polled (no subscriptions
 * in this app). Counts what concerns the viewer: root/maintainer see the whole
 * pending queue, everyone else sees access tasks assigned to them plus the ones they
 * filed. Safe for EVERY role including new_member — the resolver is
 * `@AllowNewMember`. Renders nothing at 0.
 */
const PENDING_COUNT = gql`
  query PendingAccessCount {
    pendingAccessCount
  }
`;

export function PendingAccessBadge() {
  const { data } = useQuery<{ pendingAccessCount: number }>(PENDING_COUNT, {
    pollInterval: 60_000,
    fetchPolicy: 'cache-and-network',
  });
  const n = data?.pendingAccessCount ?? 0;
  if (!n) return null;
  return <span className="nav-badge">{n}</span>;
}
